/**
 * 航拍建模状态总线：工具箱推送 → 导航栏展示
 */
const listeners = new Set();

export function publishOrthoStatus(payload) {
  const next = payload || { active: false, text: '' };
  listeners.forEach((fn) => {
    try { fn(next); } catch (_) { /* ignore */ }
  });
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('zhxt-ortho-status', { detail: next }));
  }
}

export function subscribeOrthoStatus(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
